import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-email-field',
  templateUrl: './email-field.component.html',
  styleUrls: ['./email-field.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, IonicModule, TranslateModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EmailFieldComponent),
      multi: true
    }
  ]
})
export class EmailFieldComponent implements ControlValueAccessor {
  @Input() submitted: boolean = false;
  @Input() externalError: string = '';

  emailForm: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]]
  });

  private onChange = (value: any) => {};
  private onTouched = () => {};

  constructor(private fb: FormBuilder) {
    this.emailForm.valueChanges.subscribe(value => {
      this.onChange(value);
      // Effacer l'erreur externe quand l'utilisateur modifie le champ
      if (this.externalError) {
        this.externalError = '';
      }
    });
  }

  writeValue(value: any): void {
    if (value) {
      this.emailForm.patchValue(value, { emitEvent: false });
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.emailForm.disable();
    } else {
      this.emailForm.enable();
    }
  }

  get emailControl() {
    return this.emailForm.get('email');
  }
}
